import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { Contact } from 'src/app/models/message.model';
@Component({
  selector: 'app-prospect-select-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    SelectModule,
    InputTextModule],
  templateUrl: './prospect-select-modal.component.html',
  styleUrl: './prospect-select-modal.component.scss'
})
export class ProspectSelectModalComponent {
  @Input() visible: boolean = false;
  @Input() prospectLists: Contact[] = [];
  @Input() sequence: any;
  @Output() listSelected = new EventEmitter<any>();
  @Output() cancelled = new EventEmitter<void>();
  @Output() visibleChange = new EventEmitter<boolean>();

  selectedList: any | null = null;
  searchTerm: string = '';
  filteredLists: Contact[] = [];

  ngOnInit() {
    this.filteredLists = [...this.prospectLists];
  }

  ngOnChanges() {
    if (this.visible) {
      this.resetModal();
    }
  }

  filterLists() {
    if (!this.searchTerm.trim()) {
      this.filteredLists = [...this.prospectLists];
      return;
    }

    const searchLower = this.searchTerm.toLowerCase();
    this.filteredLists = this.prospectLists.filter(list =>
      list.name.toLowerCase().includes(searchLower) ||
      (list.description && list.description.toLowerCase().includes(searchLower))
    );
  }

  onSelect() {
    if (this.selectedList) {
      this.listSelected.emit({ sequence: this.sequence, selectedList: this.selectedList });
      this.closeModal();
    }
  }

  onCancel() {
    this.cancelled.emit();
    this.closeModal();
  }

  private closeModal() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.resetModal();
  }

  private resetModal() {
    this.selectedList = null;
    this.searchTerm = '';
    this.filteredLists = [...this.prospectLists];
  }
}
